import React from "react";
import { useAuth } from "../hooks/useAuth";
import { PUBLIC_CAREERS_URL } from "../utils/constants";

// Memoized iframe that renders the working HTML via srcDoc to isolate from React
const GreenhouseInternalEmbed = React.memo(() => {
  const iframeHtml = `<!doctype html>
<html lang="en">
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <style>
      html, body { margin: 0; padding: 0; background: #ffffff; }
      #grnhse_app { min-height: 100vh; background: #ffffff; }
    </style>
  </head>
  <body>
    <div id="grnhse_app"></div>
    <script src="https://boards.greenhouse.io/embed/job_board/js?for=theperiscopegroupinternal"></script>
  </body>
</html>`;

  return (
    <iframe
      title="Internal Job Board"
      srcDoc={iframeHtml}
      style={{ width: "100%", minHeight: "1200px", border: 0 }}
    />
  );
});

/**
 * InternalJobBoard component for authenticated employees
 * Displays internal job postings with similar layout to the public JobBoard
 * Only accessible to authenticated users via ProtectedRoute
 */
const InternalJobBoard = () => {
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  const handleBackToPublic = () => {
    window.location.href = PUBLIC_CAREERS_URL;
  };

  return (
    <div className="internal-job-board">
      {/* Header Section */}
      <div className="internal-header">
        <div className="internal-navbar">
          <img
            className="group-6"
            alt="Group"
            src="https://c.animaapp.com/PMiAzVHf/img/group-44.png"
          />
          <div className="internal-nav-actions">
            <span className="welcome-text">
              Welcome, {user?.name || user?.email || "Employee"}
            </span>
            <button className="logout-nav-btn" onClick={handleLogout}>
              Logout
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="internal-content">
        <div className="internal-hero"></div>

        {/* Job Board Content - Similar to JobBoard component */}
        <div className="internal-job-container">
          <GreenhouseInternalEmbed />

          {/* Back to Public Button */}
          <div className="internal-actions">
            <button className="back-to-public-btn" onClick={handleBackToPublic}>
              Back to Public Careers Page
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InternalJobBoard;
